import { Client, cacheExchange, fetchExchange, mapExchange } from "urql";
import { AUTH_ERROR, getAPIEndpoint, getLangCode, language, tokenName } from ".";
import { jwtDecode } from "jwt-decode";
import store from "../redux/store";
import { setShowRevalidateModal } from "../redux/slices/loginSlice";
import { getItem } from "../utilities/localStorage";

const getCsrfToken = () => {
  // Cypress (browser, but test-controlled)
  if (typeof window !== "undefined" && window.Cypress) {
    return "test-token";
  }

  // Node (SSR, scripts, etc.)
  if (typeof window === "undefined") {
    return process.env.CSRF_TOKEN;
  }

  // Real browser
  return window.__CSRF_TOKEN__;
};

export const client = new Client({
  url: getAPIEndpoint(),
  exchanges: [
    cacheExchange,
    mapExchange({
      onError(error) {
        const hasGqlAuthError =
          error.graphQLErrors && error.graphQLErrors.some((gqlError) => gqlError.message.includes(AUTH_ERROR));
        const hasNetworkAuthError = error.networkError && error.networkError.message.includes(AUTH_ERROR);
        if (hasGqlAuthError || hasNetworkAuthError) {
          store().dispatch(setShowRevalidateModal({ showRevalidateModal: true }));
        }
      },
    }),
    fetchExchange,
  ],
  fetchOptions: () => {
    const token = getItem(tokenName);
    let validToken = false;
    if (token) {
      try {
        jwtDecode(token);
        validToken = true;
      } catch (err) {
        validToken = false;
      }
    }
    const csrf = getCsrfToken();

    return {
      headers: {
        authorization: validToken ? `Bearer ${token}` : "",
        "content-language": language.codes[getLangCode()],
        ...(csrf ? { "x-csrf-token": csrf } : {}),
        "content-type": "application/json",
      },
    };
  },
});
